import React, { useState } from 'react';
import clsx from 'clsx';
import { Tooltip, Box } from '@mui/material';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import useTranslation from 'hooks/useTranslation';
import ControlButton from './control-button';
import useStyles from './controls-styles';

const MapControls = ({
  provider,
  handleSettingsDrawerOpen,
  followAsset,
  follow,
  toggleReportPanel,
  toggleMeasurePanel,
  measureToggle,
  resetMap,
  closeMap,
  isClosable,
  activeQuery,
  selectedItem,
  highContrastControls,
  controlsVisible,
  zoomIn,
  zoomOut,
}) => {
  // Handle SpeedDial open and close
  const [controlsSDOpen, setControlsSDOpen] = useState(false);
  const toggleControlsSDOpen = () => {
    setControlsSDOpen(!controlsSDOpen);
  };

  // Report panel toggle on and off
  const togglePositionDetails = () => {
    toggleReportPanel();
  };

  const classes = useStyles();

  const t = useTranslation('pages.map.mapControls');
  const shouldBeDisabled = ({ name }) => {
    switch (name) {
      case 'Devices':
        return true;
      case 'Missions':
        return true;
      default:
        return false;
    }
  };

  const Accreditation = () => {
    if (provider === 'HERE') {
      return (
        <Box className={classes.hereLogo}>
          <svg xmlns="http://www.w3.org/2000/svg" width="48px" height="48px" viewBox="0 0 48 48" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <path d="M9.53148753,35.9144194 L2.7180643,29.2223656 C1.91999483,28.4385123 1.91999483,27.1524888 2.7180643,26.3686355 L5.5083082,23.628095 C6.28634759,22.863915 7.5331646,22.863915 8.31120399,23.628095 L11.1992005,26.4646468 C11.4509348,26.1165486 11.7380776,25.7836225 12.0546497,25.4726896 C13.3405491,24.2096961 15.0387401,23.5535299 16.7869972,23.6599107 C16.8346437,21.8156305 17.6220302,20.0044823 19.191235,18.4632301 C20.315429,17.3590617 21.576274,16.6380221 22.8916606,16.3072684 C22.8465428,15.738188 23.0439619,15.1534572 23.483918,14.7213382 L26.0058692,12.2443112 C26.2783543,11.9766799 26.6099373,11.8018686 26.9596395,11.7217904 C27.367233,10.3762593 28.2842023,9.29954724 29.3696066,8.7665124 C29.6394451,8.6339965 29.9278405,8.56710976 30.2145561,8.56195503 C30.6189683,7.52412868 31.2767053,6.54033902 32.1766009,5.65647371 C35.5218148,2.37084897 39.9738137,2.52080472 43.536396,5.99752281 C43.9126522,6.34234342 44.6274963,7.12179977 44.6916913,7.18485125 C45.4820358,7.96111664 45.4896867,9.2298777 44.7146436,10.0156782 L46.5292956,11.1190235 C47.3229995,11.6016116 47.6799592,12.5671573 47.3910464,13.449986 C47.2870167,13.7678687 47.0856192,14.223995 46.7604402,14.7715148 C46.2554183,15.6218447 45.5800772,16.4618092 44.7108337,17.2400507 C42.406785,19.4637939 39.7851949,20.2137698 37.2678428,19.6567593 L38.0380333,20.4132301 C38.8361027,21.1970833 38.8361027,22.4831069 38.0380333,23.2669601 L35.1404723,26.1129061 C34.8574446,26.3908921 34.5123841,26.5677551 34.1504222,26.6434949 C34.036525,26.9084333 33.8780169,27.2242472 33.6677573,27.5782716 C33.1550789,28.4414931 32.4668778,29.2940326 31.6654331,30.0002546 C30.315991,31.325772 28.905846,32.121852 27.4559023,32.4686157 C27.5414466,33.0750977 27.3484984,33.7133768 26.8770577,34.1764196 L24.1404723,36.8642574 C23.5117965,37.4817344 22.5770534,37.6002742 21.8308634,37.2198768 C22.2862941,38.4406957 21.4235596,39.9144194 19.9487805,39.9144194 L15.1325525,39.9144194 L9.81364302,45.1385818 C9.03560363,45.9027617 7.78878662,45.9027617 7.01074723,45.1385818 L1.1083082,39.3412845 C-0.169084461,38.0866463 0.71926766,35.9144194 2.5097561,35.9144194 L9.53148753,35.9144194 Z" fill="#FFFFFF" fillRule="nonzero" />
              <g id="HERE_logo" transform="translate(2, 5)" fillRule="nonzero">
                <polygon fill="#65C1C2" points="12.3146341 32.9144194 6.41219512 38.7117167 0.509756098 32.9144194" />
                <path d="M20.9536585,19.7387438 C19.7195122,18.3157708 19.7731707,17.5252303 20.5243902,16.7873924 C21.4365854,15.8914465 22.402439,16.2603654 23.4756098,17.2617167 L20.9536585,19.7387438 Z M33.6170732,3.92793296 C34.5292683,3.03198733 35.495122,3.40090646 36.5682927,4.40225728 L34.0463415,6.87928431 C32.7585366,5.45631134 32.8121951,4.7184735 33.6170732,3.92793296 Z M41.2365854,6.45766269 C40.1097561,8.14414918 38.0707317,10.8846897 35.9780488,8.82928431 L41.2902439,3.61171674 C40.8073171,3.13739274 40.4853659,2.71577122 40.1634146,2.45225771 C37.3195122,-0.340985591 34.1,-0.393688293 31.5780488,2.08333873 C29.9146341,3.71712215 29.4317073,5.61441945 29.9146341,7.40631134 L28.2512195,5.56171674 C27.8219512,5.77252755 25.7829268,7.56441945 27.2853659,10.1995546 L25.4073171,8.6711762 L22.8853659,11.1482032 L26.3195122,14.5211762 C23.6902439,12.4657708 20.8463415,12.6765816 18.5926829,14.8900951 C16.1780488,17.2617167 16.3390244,20.1603654 18.1634146,22.531987 L17.7878049,22.1630681 C15.3731707,19.7914465 12.7439024,20.6346897 11.4560976,21.8995546 C10.4365854,22.9009059 9.84634146,24.2184735 10.1146341,25.1671221 L4.9097561,20.05496 L2.1195122,22.7955005 L12.4219512,32.9144194 L17.9487805,32.9144194 L14.2463415,29.277933 C12.3146341,27.327933 12.2609756,26.3265816 13.2268293,25.377933 C14.1390244,24.481987 15.2121951,25.0617167 17.0902439,26.8536086 L20.7390244,30.4373924 L23.4756098,27.7495546 L19.9878049,24.3238789 C22.5097561,26.1684735 25.5146341,26.2738789 28.197561,23.6387438 C28.197561,23.6387438 28.2512195,23.5860411 28.2512195,23.5860411 C29.9146341,22.1103654 30.397561,20.6346897 30.397561,20.6346897 L28.304878,19.2644194 C27.1780488,20.9509059 25.1926829,23.6914465 23.1,21.6360411 L28.4121951,16.4184735 L31.7390244,19.6860411 L34.6365854,16.8400951 L30.504878,12.781987 C28.5731707,10.8846897 29.7,9.09279782 30.504878,8.40766269 C30.8804878,9.19820323 31.4170732,9.93604107 32.1146341,10.6211762 C34.797561,13.2563113 38.2317073,13.7833384 41.2902439,10.831987 C41.2902439,10.831987 41.3439024,10.7792843 41.3439024,10.7792843 C43.0073171,9.30360864 43.4902439,7.82793296 43.4902439,7.82793296 L41.2365854,6.45766269 Z" fill="#393E47" />
              </g>
            </g>
          </svg>
        </Box>
      );
    }

    return (
      <Box className={clsx(classes.accreditation, { highContrastClass: highContrastControls })}>{provider}</Box>
    );
  };

  return (
    <Box className={classes.mapControls}>
      { controlsVisible
      && (
        <>
          <Box className={classes.speedDialWrapper}>
            <SpeedDial
              ariaLabel="Map Controls"
              className={clsx(classes.speedDial, { highContrastClass: highContrastControls })}
              hidden={false}
              icon={(
                <Tooltip title="Map Tools" placement="left">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                    <path d="M13.2,5.2l-2.4-2.4l2.4-2.4C12.7,0.1,12.1,0,11.5,0C9,0,7,2,7,4.5C7,5,7.1,5.4,7.2,5.9l-6.6,4.9 c-0.8,0.6-0.8,1.7-0.2,2.4l2.3,2.4c0.7,0.7,1.8,0.6,2.4-0.2l4.9-6.6C10.5,8.9,11,9,11.5,9C14,9,16,7,16,4.5c0-0.6-0.1-1.2-0.3-1.7 L13.2,5.2z" />
                  </svg>
                </Tooltip>
              )}
              open={controlsSDOpen}
              direction="up"
            >
              {isClosable && (
                <SpeedDialAction
                  className={classes.speedDialAction}
                  key="closeMap"
                  tooltipTitle={t('closeMap')}
                  tooltipPlacement="right"
                  onClick={closeMap}
                  icon={(
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                      <path d="M14.7,1.3c-0.4-0.4-1-0.4-1.4,0L8,6.6L2.7,1.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L6.6,8l-5.3,5.3 c-0.4,0.4-0.4,1,0,1.4C1.5,14.9,1.7,15,2,15s0.5-0.1,0.7-0.3L8,9.4l5.3,5.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L9.4,8l5.3-5.3C15.1,2.3,15.1,1.7,14.7,1.3z" />
                    </svg>
                  )}
                />
              )}
              <SpeedDialAction
                className={clsx(classes.speedDialAction, { highContrastClass: highContrastControls, speedDialActionActive: measureToggle })}
                key="measurementTool"
                tooltipTitle={t('measurementTool')}
                tooltipPlacement="right"
                onClick={toggleMeasurePanel}
                disabled={!selectedItem || shouldBeDisabled(activeQuery)}
                icon={(
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                    <path d="M11,0H5C4.4,0,4,0.4,4,1v2h3v2H4v2h3v2H4v2h3v2H4v2c0,0.6,0.4,1,1,1h6c0.6,0,1-0.4,1-1V1C12,0.4,11.6,0,11,0 z" />
                  </svg>
                )}
              />
              <SpeedDialAction
                className={clsx(classes.speedDialAction, { highContrastClass: highContrastControls, speedDialActionActive: follow })}
                key="flightFollow"
                tooltipTitle={t('flightFollow')}
                tooltipPlacement="right"
                onClick={followAsset}
                disabled={!selectedItem || shouldBeDisabled(activeQuery)}
                icon={(
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                    <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M9,13.9V12H7v1.9C4.5,13.5,2.5,11.5,2.1,9H4V7H2.1 C2.5,4.5,4.5,2.5,7,2.1V4h2V2.1c2.5,0.4,4.5,2.4,4.9,4.9H12v2h1.9C13.5,11.5,11.5,13.5,9,13.9z" />
                    <circle cx="8" cy="8" r="2" />
                  </svg>
                )}
              />
              <SpeedDialAction
                className={classes.speedDialAction}
                key="resetMap"
                tooltipTitle={t('resetMap')}
                tooltipPlacement="right"
                onClick={resetMap}
                icon={(
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                    <path d="M 13.399182,0.01055162 11.782744,2.3390916 C 10.665002,1.571613 9.3164201,1.1179775 7.8630859,1.1179775 c -3.183142,0 -5.8763058,2.1578288 -6.6967488,5.0849608 H 3.1150555 C 3.8578853,4.3062822 5.695057,2.969544 7.8630859,2.969544 c 1.0678575,0 2.0547375,0.3253139 2.8711441,0.8810834 L 9.0273549,6.3099085 15.510165,6.2633998 Z M 6.4828084,9.8414765 0,9.8879845 2.1109824,16.140317 3.8002848,13.706357 c 1.1445134,0.829544 2.5465619,1.32395 4.0628011,1.32395 3.1827971,0 5.8770801,-2.158894 6.6982991,-5.0859945 h -1.948717 c -0.743513,1.8968905 -2.581769,3.2344285 -4.7495821,3.2344285 -1.1312081,0 -2.170584,-0.366596 -3.0132528,-0.984436 z" />
                  </svg>
                )}
              />
            </SpeedDial>
            <button className={clsx(classes.mapControlsButtonWrapper, { highContrastClass: highContrastControls })} onClick={toggleControlsSDOpen} type="button">
              <Tooltip title={t('mapTools')} placement="left">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                  <path d="M13.2,5.2l-2.4-2.4l2.4-2.4C12.7,0.1,12.1,0,11.5,0C9,0,7,2,7,4.5C7,5,7.1,5.4,7.2,5.9l-6.6,4.9 c-0.8,0.6-0.8,1.7-0.2,2.4l2.3,2.4c0.7,0.7,1.8,0.6,2.4-0.2l4.9-6.6C10.5,8.9,11,9,11.5,9C14,9,16,7,16,4.5c0-0.6-0.1-1.2-0.3-1.7 L13.2,5.2z" />
                </svg>
              </Tooltip>
            </button>
          </Box>
          <Box className={clsx({ [classes.rounded]: provider === 'HERE' })}>
            <ControlButton tooltipPlacement="top" text={t('mapSettings')} onClick={handleSettingsDrawerOpen} className={clsx({ highContrastClass: highContrastControls })}>
              <polygon points="8,13.4 2.1,9.7 0,11 8,16 16,11 13.9,9.7" />
              <polygon points="0,6 8,1 16,6 8,11" />
            </ControlButton>
          </Box>
          {
            provider !== 'HERE' && <Accreditation />
          }
          <button className={clsx([classes.zoomButtons, classes.zoomIn], { highContrastClass: highContrastControls })} onClick={zoomIn} type="button">
            <Tooltip title={t('zoomIn')} placement="top">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <path d="M15,7H9V1c0-0.6-0.4-1-1-1S7,0.4,7,1v6H1C0.4,7,0,7.4,0,8s0.4,1,1,1h6v6c0,0.6,0.4,1,1,1s1-0.4,1-1V9h6 c0.6,0,1-0.4,1-1S15.6,7,15,7z" />
              </svg>
            </Tooltip>
          </button>
          <button className={clsx([classes.zoomButtons, classes.zoomOut], { highContrastClass: highContrastControls })} onClick={zoomOut} type="button">
            <Tooltip title={t('zoomOut')} placement="top">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <path d="M15,7H1C0.4,7,0,7.4,0,8s0.4,1,1,1h14c0.6,0,1-0.4,1-1S15.6,7,15,7z" />
              </svg>
            </Tooltip>
          </button>
        </>
      )}
      {
        provider === 'HERE' && <Accreditation />
      }
    </Box>
  );
};

export default MapControls;
